module.exports = __webpack_public_path__ + "img/signup-carousel-fourth.72cf6fad.png";